import React, { useEffect, useContext } from 'react'
import analytics from '@mobi/libraries/analytics'
import Header from './components/Header'
import LandingHero from './components/LandingHero'
import LandingFeatures from './components/LandingFeatures'
import LandingPartners from './components/LandingPartners'
import LandingAdvantages from './components/LandingAdvantages'
import LandingTestimonials from './components/LandingTestimonials'
import LandingExpress from './components/LandingExpress'
import LandingFaq from './components/LandingFaq'
import LandingFooter from './components/LandingFooter'
import LandingLayout from '../../layouts/LandingLayout'
import WhatsAppButton from 'components/WhatsAppButton'
import storage from 'utils/storage'
import { addNRPageView, trackNRPage } from 'utils/trackings/newRelicEvents.js'
import isClient from 'utils/isClient.js'
import analyticsUuid from 'utils/analyticsUuid.js'
import handleInternalTracking from 'utils/trackings/handleInternalTracking.js'
import { ThemeContext } from 'modules/Theme'
import './Landing.scss'

const Landing = ({ pageContext, location }) => {
  const { setTheme } = useContext(ThemeContext)

  useEffect(() => {
    analyticsUuid.clearKeepingAnalyticsUuid()

    storage.local.setItem('callbackUrl', isClient() && window.location.href)

    storage.session.setItem('keepSession', true)

    storage.local.removeItem('isLojasAvenida')

    const isLojasAvenida = storage.local.getItem('isLojasAvenida')
    const origin = isLojasAvenida ? 'recovery' : pageContext?.slug
    setTheme(origin || 'recovery')

    if (window.location.href.includes('lojasavenida')) {
      storage.local.setItem('isLojasAvenida', true)
      setTheme('recovery')
    }

    addNRPageView('lp_home')
    analytics.track('gaPageLoad', {
      pageName: 'LandingPage:RenegocieGrupoRecovery:RV',
    })
    analytics.track('LPPageView')
    trackNRPage({ pageName: 'LP' })
    handleInternalTracking('lp_visit')
  }, [])

  return (
    <LandingLayout>
      <div className="landing-container">
        <WhatsAppButton />

        <Header />
        <LandingHero location={location} />
        <LandingPartners />
        <LandingExpress />
        <LandingFeatures />
        <LandingAdvantages />
        <LandingTestimonials />
        <LandingFaq />
        <LandingFooter />
      </div>
    </LandingLayout>
  )
}

export default Landing
